import React from 'react'
import styled from 'styled-components'
import { getThemeStyle } from '../../utilities/helpers'

const ThemeBadge = ({themeTitle, themeIndex}) => {
  return (
    <Badge
      className="theme-badge"
      style={{
        backgroundColor: getThemeStyle(themeIndex).bgColor,
      }}
    >
      <CatalystTitle>{themeTitle}</CatalystTitle>
    </Badge>
  )
}

export default ThemeBadge;

const Badge = styled.span`
  border-radius: 10px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 1px 10px 0 10px;
  overflow: hidden;
  margin-right: 5px;
  color: #fff;
`;

const CatalystTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


// WEBPACK FOOTER //
// ./src/components/ui/theme-badge.js